import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import * as moment from 'moment';
import JsonPretty from '../JsonPretty';

type Props = RouteComponentProps<{
    accountId: string;
}>

type State = {
    auditlog: AuditLogData[];
    isLoading: boolean;
    accountId: number;
}

type AuditLogData = {
    AuditLogID: number;
    UserName: string;
    OldValues: string;
    NewValues: string;
    DateTime: Date;
}

export default class AuditLog extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: true,
            auditlog: [],
            accountId: 0,
        }
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let accountId = parseInt(this.props.match.params.accountId) || 0;
        this.requestAuditLogs(accountId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let accountId = parseInt(nextProps.match.params.accountId) || 0;

        if (this.state.auditlog && this.state.accountId != accountId) {
            this.requestAuditLogs(accountId);
        }
    }

    public render() {
        return <div>
            <br/>
            <table className="table">
                <thead>
                    <tr>
                        <th>User</th>
                        <th>Timestamp</th>
                        <th>Old Values</th>
                        <th>New Values</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.auditlog.map((note, index) => {
                        return <tr key={index}>
                                <td>{note.UserName || "SYSTEM"}</td>
                                <td>{moment.utc(note.DateTime).local().format("YYYY-MM-DD HH:mm")}</td>
                                <td><JsonPretty json={note.OldValues} /></td>
                                <td><JsonPretty json={note.NewValues} /></td>
                            </tr>
                    })}
                </tbody>
            </table>
        </div>
    }

    private requestAuditLogs(accountId: number) {
        this.setState({ isLoading: true, accountId });
        fetchApi(`api/AuditLog/Accounts/${accountId}`)
            .then((auditlog: AuditLogData[]) => {
                this.setState({ isLoading: false, auditlog });
            });
    }
}
